<div
    class="flex flex-col w-full border-2 border-primary rounded-xl absolute cursor-pointer z-30 px-[4px] pt-[4px]"
    [ngClass]="{
        'pointer-events-none': partnerAvailable,
        'bg-[linear-gradient(to_bottom,transparent_40px,var(--p-content-background)_40px)]':
            !isToday,
        'bg-[linear-gradient(to_bottom,transparent_40px,var(--today-column-color)_40px)]': isToday,
    }"
    [ngStyle]="{
        'height.px': outlineHeight,
    }">
    <div
        class="rounded-lg h-9 w-9 flex items-center justify-center bg-primary"
        [ngClass]="{ 'opacity-50': partnerAvailable }">
        <i class="pi pi-check text-white/100"></i>
    </div>
    <div
        class="text-xs font-normal text-muted-color pb-[4px] pr-[4px] flex items-center justify-start gap-[4px]">
        <fm-session-indicator-icons
            [isQuietMode]="quietMode"
            [activityType]="activityType"
            [sessionDuration]="sessionDuration"
            [showActivityType]="true"
            [isLockedIn]="false"
            [showTooltips]="false"
            [showPreferFavorites]="
                sessionSettingsService.preferFavoritesSetting() === 'preferred'
            " />
    </div>
</div>
